"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCTrackerModel = void 0;
var VRCTrackerModel;
(function (VRCTrackerModel) {
    VRCTrackerModel[VRCTrackerModel["UNKNOWN"] = 0] = "UNKNOWN";
    VRCTrackerModel[VRCTrackerModel["SPHERE"] = 1] = "SPHERE";
    VRCTrackerModel[VRCTrackerModel["SYSTEM"] = 2] = "SYSTEM";
    VRCTrackerModel[VRCTrackerModel["BOX"] = 3] = "BOX";
    VRCTrackerModel[VRCTrackerModel["AXIS"] = 4] = "AXIS";
})(VRCTrackerModel = exports.VRCTrackerModel || (exports.VRCTrackerModel = {}));
